// @storybook-skip: internal section of LessonsHomeScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import type { LessonMeta } from "./types";

type Props = {
	meta: LessonMeta;
};

export const LessonMetaRow = ({ meta }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box flexDirection="row" alignItems="center" gap={6} flexWrap="wrap">
			<Text
				variant="bodySmall"
				style={{ color: theme.colors.onSurfaceVariant }}
			>
				{meta.specialty}
			</Text>
			<Text
				variant="bodySmall"
				style={{ color: theme.colors.onSurfaceVariant }}
			>
				•
			</Text>
			<Text
				variant="bodySmall"
				style={{ color: theme.colors.onSurfaceVariant }}
			>
				{t("lessons.home.card.duration", { count: meta.durationMinutes })}
			</Text>
		</Box>
	);
};
